import { Component, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { DateAdapter } from '@angular/material/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatDatepicker } from '@angular/material/datepicker';
import { MaterialModule } from 'src/app/material.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [MaterialModule, TranslateModule],
  selector: 'app-date-picker-header',
  styleUrls: ['./date-picker-header.component.scss'],
  template: `
    <mat-calendar-header>
      <button mat-flat-button color="primary" (click)="todayClicked()">{{ 'today' | translate }}</button>
    </mat-calendar-header>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class DatePickerHeader<D> implements OnDestroy {
  private destroyed = new Subject<void>();

  constructor(
    private calendar: MatCalendar<D>,
    private dateAdapter: DateAdapter<D>,
    private changeDetectorRef: ChangeDetectorRef,
    private datepicker: MatDatepicker<D>
  ) {
    this.calendar.stateChanges.pipe(takeUntil(this.destroyed)).subscribe(() => this.changeDetectorRef.markForCheck());
  }

  todayClicked() {
    const today = this.dateAdapter.today();
    this.calendar.activeDate = today;
    this.calendar.selected = today;
    this.datepicker.select(today);
    this.datepicker.close();
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
